import { FeatureFlag } from '../FeatureFlag';

export const enableLlmNlp = new FeatureFlag({
    key: 'enable-llm-nlp',
    createdOn: '2026-03-17',
    defaultValue: false,
});
